import React, { useEffect, useState } from 'react';
import { getToken } from '../utils/cookieUtils';
import Nav from "../components/Nav";
import LoggedNav from "../components/LoggedNav";
import AddAddressDetails from "../components/AddAddressDetails";

function AddCard(props) {
  return (
    <>
      {getToken() ? <LoggedNav customer={props.customer} /> : <Nav customer={props.customer} />}
      <AddAddressDetails image={props.image} customer={props.customer} />
    </>
  );
}

export default AddCard;
